import { ForwardedRef, forwardRef } from "react";
import { twMerge } from "tailwind-merge";

export type OverlayProps = {
  className?: string;
  zIndex?: number;
};

const Overlay = forwardRef(
  ({ className = "h-full w-full", zIndex = 10 }: OverlayProps, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <div
        ref={ref}
        className={twMerge("fixed bg-white bg-opacity-70 transition-opacity", className)}
        style={{ zIndex, left: "0px", top: "0px" }}
      />
    );
  },
);

export default Overlay;
